const settings = {
    MANAGER_URL: window.env?.MANAGER_URL
  };
  
  export default settings;